/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  Derived,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AiAgentError = {
  errorType: Default<ErrorType>;
  retryAfterSeconds?: number;
  portalId?: number;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType =
  | 'NOT_FOUND'
  | 'UNKNOWN_ERROR'
  | 'INTERNAL_ERROR'
  | 'IO_EXCEPTION'
  | 'INVALID_DATA'
  | 'UNSUPPORTED_MODEL'
  | 'MISSING_REQUIRED_INPUTS'
  | 'INPUT_SIZE_EXCEEDED'
  | 'FILE_VALIDATION_FAILED'
  | 'AGENT_NOT_EXECUTABLE'
  | 'MISSING_ACTION_COMPONENTS'
  | 'INACTIVE_TEMPLATE'
  | 'INVALID_AGENT_STATUS'
  | 'IN_PROCESS_ERROR'
  | 'CHIRP_ERROR'
  | 'GEN_AI_ERROR'
  | 'GARAGE_ERROR'
  | 'MISSING_SCOPES'
  | 'MISSING_ACCESS_CONTROLS'
  | 'MISSING_AI_PERMISSIONS'
  | 'AGENT_INTERNAL_ERROR'
  | 'SCHEMA_ERROR'
  | 'PERMISSION_DENIED'
  | 'VIEW_PERMISSION_DENIED'
  | 'RUN_PERMISSION_DENIED'
  | 'EDIT_PERMISSION_DENIED'
  | 'MANAGE_AUTOMATIONS_PERMISSION_DENIED'
  | 'ADMIN_PERMISSION_DENIED'
  | 'EXECUTING_USER_NOT_FOUND'
  | 'RATE_LIMITED'
  | 'HOURLY_TOKEN_LIMIT_EXCEEDED'
  | 'DAILY_TOKEN_LIMIT_EXCEEDED'
  | 'HOURLY_RUN_LIMIT_EXCEEDED'
  | 'DAILY_RUN_LIMIT_EXCEEDED'
  | 'MONTHLY_RUN_LIMIT_EXCEEDED'
  | 'MONTHLY_CREDIT_LIMIT_EXCEEDED'
  | 'DAILY_TEST_RUN_LIMIT_EXCEEDED'
  | 'FEATURE_DISABLED'
  | 'CONTEXT_WINDOW_EXCEEDED'
  | 'GUARDRAIL_VIOLATION'
  | 'CONCURRENT_EDIT_CONFLICT'
  | unhandledEnumCase;

export const ActionComponentTypename =
  'com.hubspot.ai.agent.models.core.ActionComponent';
export const ActionComponentDiscriminant = 'ACTION';
export const ActionComponentDiscriminantKey = 'type';
export type ActionComponent = {
  actionTypeId: string;
  curryingConfigurations: Default<CurryingConfiguration[]>;
  toolId?: string;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.ActionComponent';
} & { type?: 'ACTION' };

export const AgentComponentTypename =
  'com.hubspot.ai.agent.models.core.AgentComponent';
export const AgentComponentDiscriminant = 'AGENT';
export const AgentComponentDiscriminantKey = 'type';
export type AgentComponent = {
  agentInstanceId: number;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.AgentComponent';
} & { type?: 'AGENT' };

export type AgentConnectionType = 'WORKFLOW' | 'CRM_CARD' | unhandledEnumCase;

export const AgentInputDiscriminantKey = '@type';
export type AgentInput =
  | BooleanAgentInput
  | NumberAgentInput
  | StringAgentInput
  | ListAgentInput
  | MapAgentInput
  | FileAgentInput
  | FilesAgentInput
  | CrmObjectCoordinatesAgentInput
  | NullAgentInput;

export type AgentInstancePortabilityMetadata = {
  sourcePortalId?: number;
  sourceAgentInstanceId?: number;
  sourceSnapshotId?: number;
};

export type AgentInstanceTemplateMetadata = {
  originalTemplateMetadata?: AgentMetadata;
  templateMetadata?: AgentMetadata;
  portabilityMetadata?: AgentInstancePortabilityMetadata;
  createdFrom?: CreatedFrom;
  creationSource?: CreationSource;
  creationSourceId?: string;
};

export type AgentKnowledgeBoxManagementType =
  | 'HS_KAAS'
  | 'HS_OTHER'
  | 'USER'
  | unhandledEnumCase;

export type AgentMetadata = {
  id?: number;
  globalId?: number;
  version?: number;
  name?: string;
};

export type AgentSettings = {
  enablePIIMAsking: Default<boolean>;
  enableSmartOutputs: Default<boolean>;
  enablePromptGuard: Default<boolean>;
  overrides: Default<AgentExecuteOverrides>;
  enableFlexTierForBackgroundTasks: Default<boolean>;
  enableTranslations: Default<boolean>;
  enableThreadCompaction: Default<boolean>;
  threadCompactionThreshold: Default<number>;
  enableFileSandbox: Default<boolean>;
  totalHourlyRateLimit?: number;
};

export type AgentStatus =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'DRAFT'
  | 'TEST'
  | unhandledEnumCase;

export type AgentStep = {
  actionId: number;
  missingInputs: Default<MissingInput[]>;
};

export const AgentTemplateComponentTypename =
  'com.hubspot.ai.agent.models.core.AgentTemplateComponent';
export const AgentTemplateComponentDiscriminant = 'AGENT_TEMPLATE';
export const AgentTemplateComponentDiscriminantKey = 'type';
export type AgentTemplateComponent = {
  templateGlobalId: number;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.AgentTemplateComponent';
} & { type?: 'AGENT_TEMPLATE' };

export type AgentTrigger =
  | 'SCHEDULED'
  | 'MANUAL'
  | 'EVENT'
  | 'AGENT_TO_AGENT'
  | unhandledEnumCase;

export type AgentVisibility =
  | 'PUBLIC'
  | 'INTERNAL'
  | 'WORKFLOW'
  | unhandledEnumCase;

export type AppDependency = {
  appId: number;
  appName: string;
  isInternal: Default<boolean>;
  isPublic: Default<boolean>;
  isUserLevel: Default<boolean>;
};

export const AviatorAgentComponentTypename =
  'com.hubspot.ai.agent.models.core.AviatorAgentComponent';
export const AviatorAgentComponentDiscriminant = 'AVIATOR_SUBAGENT';
export const AviatorAgentComponentDiscriminantKey = 'type';
export type AviatorAgentComponent = {
  name: string;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.AviatorAgentComponent';
} & { type?: 'AVIATOR_SUBAGENT' };

export const BooleanAgentInputTypename =
  'com.hubspot.ai.agent.models.core.BooleanAgentInput';
export const BooleanAgentInputDiscriminant = 'boolean';
export const BooleanAgentInputDiscriminantKey = '@type';
export type BooleanAgentInput = {
  value: boolean;
  __typename: 'com.hubspot.ai.agent.models.core.BooleanAgentInput';
} & { '@type'?: 'boolean' };

export const BuiltInToolComponentTypename =
  'com.hubspot.ai.agent.models.core.BuiltInToolComponent';
export const BuiltInToolComponentDiscriminant = 'BUILT_IN';
export const BuiltInToolComponentDiscriminantKey = 'type';
export type BuiltInToolComponent = {
  tool: BuiltInToolType;
  toolConfiguration: Default<Record<string, string>>;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.BuiltInToolComponent';
} & { type?: 'BUILT_IN' };

export const ChirpRpcComponentTypename =
  'com.hubspot.ai.agent.models.core.ChirpRpcComponent';
export const ChirpRpcComponentDiscriminant = 'CHIRP_RPC';
export const ChirpRpcComponentDiscriminantKey = 'type';
export type ChirpRpcComponent = {
  fqn: string;
  method: string;
  useStrictMode: Default<boolean>;
  curryingConfigurations: Default<CurryingConfiguration[]>;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.ChirpRpcComponent';
} & { type?: 'CHIRP_RPC' };

export const ChirpToolBundleComponentTypename =
  'com.hubspot.ai.agent.models.core.ChirpToolBundleComponent';
export const ChirpToolBundleComponentDiscriminant = 'CHIRP_TOOL_BUNDLE';
export const ChirpToolBundleComponentDiscriminantKey = 'type';
export type ChirpToolBundleComponent = {
  category: BuiltInToolCategory;
  toolId?: string;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.ChirpToolBundleComponent';
} & { type?: 'CHIRP_TOOL_BUNDLE' };

export const ComponentV2DiscriminantKey = 'type';
export type ComponentV2 =
  | SkillComponent
  | ActionComponent
  | KnowledgeBoxComponent
  | McpServerComponent
  | McpServerV2Component
  | AgentComponent
  | AgentTemplateComponent
  | ChirpRpcComponent
  | HookComponent
  | BuiltInToolComponent
  | ChirpToolBundleComponent
  | AviatorAgentComponent
  | WebhookComponent;

export const ConnectionDetailDiscriminantKey = 'type';
export type ConnectionDetail = WorkflowConnectionData | CrmCardConnectionData;

export const CreatedFromDiscriminantKey = 'origin';
export type CreatedFrom = PortabilityCreatedFrom | RecommendationCreatedFrom;

export type CreationSource =
  | 'PLAN_MODE'
  | 'PLAN_MODE_SKIPPED'
  | 'TEMPLATE'
  | 'PORTED'
  | 'JTBD_PROMPT_SUGGESTION'
  | 'PORTAL_USAGE_CONTEXT'
  | unhandledEnumCase;

export const CrmCardConnectionDataTypename =
  'com.hubspot.ai.agent.models.core.CrmCardConnectionData';
export const CrmCardConnectionDataDiscriminant = 'CRM_CARD';
export const CrmCardConnectionDataDiscriminantKey = 'type';
export type CrmCardConnectionData = {
  cardId: string;
  cardTitle?: string;
  cardLocation?: string;
  createdBy?: number;
  objectTypeId?: string;
  url?: string;
  __typename: 'com.hubspot.ai.agent.models.core.CrmCardConnectionData';
} & { type?: 'CRM_CARD' };

export const CrmObjectCoordinatesAgentInputTypename =
  'com.hubspot.ai.agent.models.core.CrmObjectCoordinatesAgentInput';
export const CrmObjectCoordinatesAgentInputDiscriminant = 'object';
export const CrmObjectCoordinatesAgentInputDiscriminantKey = '@type';
export type CrmObjectCoordinatesAgentInput = {
  value: ObjectCoordinates;
  __typename: 'com.hubspot.ai.agent.models.core.CrmObjectCoordinatesAgentInput';
} & { '@type'?: 'object' };

export type CurryingConfiguration = {
  description: string;
  overrides: Default<FieldOverride[]>;
};

export type FieldOverride = { fieldName: string; value: FieldValue };

export const FileAgentInputTypename =
  'com.hubspot.ai.agent.models.core.FileAgentInput';
export const FileAgentInputDiscriminant = 'file';
export const FileAgentInputDiscriminantKey = '@type';
export type FileAgentInput = {
  value: FileInput;
  __typename: 'com.hubspot.ai.agent.models.core.FileAgentInput';
} & { '@type'?: 'file' };

export type FileInput = { fileId: number; url?: string; title?: string };

export const FilesAgentInputTypename =
  'com.hubspot.ai.agent.models.core.FilesAgentInput';
export const FilesAgentInputDiscriminant = 'files';
export const FilesAgentInputDiscriminantKey = '@type';
export type FilesAgentInput = {
  value: Default<FileInput[]>;
  __typename: 'com.hubspot.ai.agent.models.core.FilesAgentInput';
} & { '@type'?: 'files' };

export const HookComponentTypename =
  'com.hubspot.ai.agent.models.core.HookComponent';
export const HookComponentDiscriminant = 'HOOK';
export const HookComponentDiscriminantKey = 'type';
export type HookComponent = {
  hookType: HookType;
  boxId?: number;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.HookComponent';
} & { type?: 'HOOK' };

export type InputSource = {
  url?: string;
  valueKey?: string;
  labelKey?: string;
  requestPayload?: string;
  httpMethod?: InputSourceHttpMethod;
  dataKey?: string;
  multiChoice: boolean;
  requestType: RequestType;
  crmSearchType?: CrmSearchType;
};

export const KnowledgeBoxComponentTypename =
  'com.hubspot.ai.agent.models.core.KnowledgeBoxComponent';
export const KnowledgeBoxComponentDiscriminant = 'KNOWLEDGE_BOX';
export const KnowledgeBoxComponentDiscriminantKey = 'type';
export type KnowledgeBoxComponent = {
  boxId: number;
  includeFullText: Default<boolean>;
  maxResultsPerSource: Default<number>;
  rerankerTopN: Default<number>;
  topK: Default<number>;
  managementType: Default<AgentKnowledgeBoxManagementType>;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.KnowledgeBoxComponent';
} & { type?: 'KNOWLEDGE_BOX' };

export const ListAgentInputTypename =
  'com.hubspot.ai.agent.models.core.ListAgentInput';
export const ListAgentInputDiscriminant = 'list';
export const ListAgentInputDiscriminantKey = '@type';
export type ListAgentInput = {
  value: Default<AgentInput[]>;
  __typename: 'com.hubspot.ai.agent.models.core.ListAgentInput';
} & { '@type'?: 'list' };

export const MapAgentInputTypename =
  'com.hubspot.ai.agent.models.core.MapAgentInput';
export const MapAgentInputDiscriminant = 'map';
export const MapAgentInputDiscriminantKey = '@type';
export type MapAgentInput = {
  value: Default<Record<string, AgentInput>>;
  __typename: 'com.hubspot.ai.agent.models.core.MapAgentInput';
} & { '@type'?: 'map' };

export const McpServerComponentTypename =
  'com.hubspot.ai.agent.models.core.McpServerComponent';
export const McpServerComponentDiscriminant = 'MCP_SERVER';
export const McpServerComponentDiscriminantKey = 'type';
export type McpServerComponent = {
  name: string;
  description?: string;
  url: Default<string>;
  authenticatorId?: string;
  allowedTools: Default<string[]>;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.McpServerComponent';
} & { type?: 'MCP_SERVER' };

export const McpServerV2ComponentTypename =
  'com.hubspot.ai.agent.models.core.McpServerV2Component';
export const McpServerV2ComponentDiscriminant = 'MCP_SERVER_V2';
export const McpServerV2ComponentDiscriminantKey = 'type';
export type McpServerV2Component = {
  id: number;
  name: string;
  description?: string;
  authenticatorId?: string;
  allowedTools: Default<string[]>;
  toolId?: string;
  disabled: Default<boolean>;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.McpServerV2Component';
} & { type?: 'MCP_SERVER_V2' };

export type MissingInput = { name: string; label?: string };

export const NullAgentInputTypename =
  'com.hubspot.ai.agent.models.core.NullAgentInput';
export const NullAgentInputDiscriminant = 'null';
export const NullAgentInputDiscriminantKey = '@type';
export type NullAgentInput = {
  __typename: 'com.hubspot.ai.agent.models.core.NullAgentInput';
} & { '@type'?: 'null' };

export const NumberAgentInputTypename =
  'com.hubspot.ai.agent.models.core.NumberAgentInput';
export const NumberAgentInputDiscriminant = 'number';
export const NumberAgentInputDiscriminantKey = '@type';
export type NumberAgentInput = {
  value: string;
  __typename: 'com.hubspot.ai.agent.models.core.NumberAgentInput';
} & { '@type'?: 'number' };

export const PortabilityCreatedFromTypename =
  'com.hubspot.ai.agent.models.core.PortabilityCreatedFrom';
export const PortabilityCreatedFromDiscriminant = 'PORTABILITY';
export const PortabilityCreatedFromDiscriminantKey = 'origin';
export type PortabilityCreatedFrom = {
  sourcePortalId?: number;
  sourceAgentInstanceId?: number;
  sourceSnapshotId?: number;
  __typename: 'com.hubspot.ai.agent.models.core.PortabilityCreatedFrom';
} & { origin?: 'PORTABILITY' };

export const RecommendationCreatedFromTypename =
  'com.hubspot.ai.agent.models.core.RecommendationCreatedFrom';
export const RecommendationCreatedFromDiscriminant = 'RECOMMENDATION';
export const RecommendationCreatedFromDiscriminantKey = 'origin';
export type RecommendationCreatedFrom = {
  recommendationSource: RecommendationSource;
  recommendationId: string;
  __typename: 'com.hubspot.ai.agent.models.core.RecommendationCreatedFrom';
} & { origin?: 'RECOMMENDATION' };

export const SkillComponentTypename =
  'com.hubspot.ai.agent.models.core.SkillComponent';
export const SkillComponentDiscriminant = 'SKILL';
export const SkillComponentDiscriminantKey = 'type';
export type SkillComponent = {
  skillId: number;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  requiresApproval: Default<boolean>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.SkillComponent';
} & { type?: 'SKILL' };

export const StringAgentInputTypename =
  'com.hubspot.ai.agent.models.core.StringAgentInput';
export const StringAgentInputDiscriminant = 'string';
export const StringAgentInputDiscriminantKey = '@type';
export type StringAgentInput = {
  value: string;
  __typename: 'com.hubspot.ai.agent.models.core.StringAgentInput';
} & { '@type'?: 'string' };

export const WebhookComponentTypename =
  'com.hubspot.ai.agent.models.core.WebhookComponent';
export const WebhookComponentDiscriminant = 'WEBHOOK';
export const WebhookComponentDiscriminantKey = 'type';
export type WebhookComponent = {
  actionTypeId: string;
  requiresApproval: Default<boolean>;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  approvalOverride: Default<boolean>;
  __typename: 'com.hubspot.ai.agent.models.core.WebhookComponent';
} & { type?: 'WEBHOOK' };

export type WorkflowAgentSteps = {
  steps: Default<AgentStep[]>;
  isAgentUnpublished: Default<boolean>;
};

export const WorkflowConnectionDataTypename =
  'com.hubspot.ai.agent.models.core.WorkflowConnectionData';
export const WorkflowConnectionDataDiscriminant = 'WORKFLOW';
export const WorkflowConnectionDataDiscriminantKey = 'type';
export type WorkflowConnectionData = {
  id: number;
  name?: string;
  description?: string;
  isEnabled?: boolean;
  isModern?: boolean;
  agentSteps?: WorkflowAgentSteps;
  __typename: 'com.hubspot.ai.agent.models.core.WorkflowConnectionData';
} & { type?: 'WORKFLOW' };

export type BuiltInToolCategory =
  | 'WEB_SEARCH'
  | 'CRM'
  | 'CRM_WRITE'
  | 'OPERATIONAL'
  | 'FILES'
  | 'BRAND'
  | 'IDEAL_CUSTOMER_PROFILES'
  | 'PRODUCTS_AND_SERVICES'
  | 'SALES_METHODOLOGY'
  | 'EMAIL_PERSONALITY'
  | 'CUSTOM_COMPANY_CONTEXT'
  | 'BUYER_PROFILES'
  | 'SELLING_PROFILES'
  | unhandledEnumCase;

export type BuiltInToolType =
  | 'WEB_SEARCH'
  | 'EXA_WEB_SEARCH'
  | 'EXA_CONTENT_SEARCH'
  | 'MANAGE_CHECKLIST'
  | 'THINK'
  | 'OBJECT_SEARCH'
  | 'CODE_INTERPRETER'
  | 'READ_FILE_CONTENT'
  | unhandledEnumCase;

export type ComponentType =
  | 'SKILL'
  | 'AGENT'
  | 'ACTION'
  | 'KNOWLEDGE_BOX'
  | 'MCP_SERVER'
  | 'MCP_SERVER_V2'
  | 'CHIRP_RPC'
  | 'BUILT_IN'
  | 'HOOK'
  | 'AGENT_TEMPLATE'
  | 'CHIRP_TOOL_BUNDLE'
  | 'AVIATOR_AGENT'
  | 'WEBHOOK'
  | unhandledEnumCase;

export type HookType =
  | 'STORE_KNOWLEDGE_POST_RUN'
  | 'UPLOAD_FILE_PRE_RUN'
  | unhandledEnumCase;

export type CrmSearchType =
  | 'CALL'
  | 'COMPANY'
  | 'CONTACT'
  | 'DEAL'
  | 'CRM_EMAIL'
  | 'EMAIL'
  | 'MEETING'
  | 'MARKETING_EVENT'
  | 'OBJECT_LIST'
  | 'CAMPAIGN'
  | 'NOTE'
  | 'TASK'
  | 'TICKET'
  | 'USER'
  | 'CUSTOM_OBJECT'
  | unhandledEnumCase;

export type InputSourceHttpMethod = 'GET' | 'POST' | unhandledEnumCase;

export type RequestType = 'HTTP' | 'CHIRP' | 'CRMSEARCH' | unhandledEnumCase;

export type AgentInputDefinition = {
  name: string;
  description: string;
  valueType: string;
  required: boolean;
  inputSource?: InputSource;
  persistent: Default<boolean>;
  inputTitleText: string;
  inputDescriptionText?: string;
  placeholderText: string;
  position?: number;
};

export type AgentExecuteOverrides = { systemPromptTemplate?: string };

export type ModelParameters = {
  maxTokens: Default<number>;
  temperature?: string;
  reasoningEffort?: ReasoningEffort;
  reasoningVerbosity?: ReasoningVerbosity;
  textVerbosity?: TextVerbosity;
};

export type ReasoningEffort =
  | 'MINIMAL'
  | 'LOW'
  | 'MEDIUM'
  | 'HIGH'
  | 'NONE'
  | unhandledEnumCase;

export type ReasoningVerbosity =
  | 'AUTO'
  | 'CONCISE'
  | 'DETAILED'
  | unhandledEnumCase;

export type TextVerbosity = 'LOW' | 'MEDIUM' | 'HIGH' | unhandledEnumCase;

export type AgentInstanceMetadata = { id: number; name: string; icon?: string };

export type AgentInstanceSnapshot = {
  id: number;
  agentInstanceId: number;
  portalId: number;
  createdById: number;
  snapshotName?: string;
  snapshotMetadata: Default<Record<string, string>>;
  isAutoSaved: boolean;
  wasLive: boolean;
  wasRestored: boolean;
  unpublishReasons?: string[];
  versionNumber?: number;
  expiresAt?: number;
  createdAt: number;
  updatedAt: number;
  status: AgentStatus;
  objective: Default<string>;
  /** @deprecated */
  templateName?: string;
  templateId?: number;
  templateMetadata: Default<AgentInstanceTemplateMetadata>;
  workflowId?: number;
  isBreezeEnabled: Default<boolean>;
  name: string;
  description: string;
  icon?: string;
  modelId?: string;
  modelParameters: Default<ModelParameters>;
  outputType: Default<ResponseSectionType>;
  inputDefinitions: Default<Record<string, AgentInputDefinition>>;
  components: Default<ComponentV2[]>;
  appDependencies: Default<AppDependency[]>;
  builtInTools: Default<BuiltInToolCategory[]>;
  visibility: AgentVisibility;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  deletedAt?: number;
  setupInputs: Default<Record<string, AgentInput>>;
  agentSettings: Default<AgentSettings>;
  derivedScopes: Derived<string[]>;
  derivedAiAccessControls: Derived<string[]>;
};

export type AgentInstanceV2 = {
  portalId: number;
  lastSnapshotVersionNumber?: number;
  id: number;
  snapshotId?: number;
  status: AgentStatus;
  objective: Default<string>;
  /** @deprecated */
  templateName?: string;
  templateId?: number;
  templateMetadata: Default<AgentInstanceTemplateMetadata>;
  workflowId?: number;
  isBreezeEnabled: Default<boolean>;
  /** @deprecated */
  authorName: Default<string>;
  updatedByName?: string;
  createdBy: number;
  createdAt: number;
  updatedAt: Default<number>;
  updatedBy: Default<number>;
  name: string;
  description: string;
  icon?: string;
  modelId?: string;
  modelParameters: Default<ModelParameters>;
  outputType: Default<ResponseSectionType>;
  inputDefinitions: Default<Record<string, AgentInputDefinition>>;
  components: Default<ComponentV2[]>;
  appDependencies: Default<AppDependency[]>;
  builtInTools: Default<BuiltInToolCategory[]>;
  visibility: AgentVisibility;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  deletedAt?: number;
  setupInputs: Default<Record<string, AgentInput>>;
  agentSettings: Default<AgentSettings>;
  derivedScopes: Derived<string[]>;
  derivedAiAccessControls: Derived<string[]>;
};

export type AgentInstanceV2CreateRequest = {
  status: AgentStatus;
  objective: Default<string>;
  /** @deprecated */
  templateName?: string;
  templateId?: number;
  templateMetadata: Default<AgentInstanceTemplateMetadata>;
  workflowId?: number;
  isBreezeEnabled: Default<boolean>;
  name: string;
  description: string;
  icon?: string;
  modelId?: string;
  modelParameters: Default<ModelParameters>;
  outputType: Default<ResponseSectionType>;
  inputDefinitions: Default<Record<string, AgentInputDefinition>>;
  components: Default<ComponentV2[]>;
  appDependencies: Default<AppDependency[]>;
  builtInTools: Default<BuiltInToolCategory[]>;
  visibility: AgentVisibility;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  deletedAt?: number;
  setupInputs: Default<Record<string, AgentInput>>;
  agentSettings: Default<AgentSettings>;
  derivedScopes: Derived<string[]>;
  derivedAiAccessControls: Derived<string[]>;
};

export type AgentInstanceV2PartialUpdateRequest = {
  name?: string;
  description?: string;
  icon?: string;
  modelId?: string;
  modelParameters?: ModelParameters;
  objective?: string;
  outputType?: ResponseSectionType;
  visibility?: AgentVisibility;
  agentSettings?: AgentSettings;
  inputDefinitions?: Record<string, AgentInputDefinition>;
  components?: ComponentV2[];
  appDependencies?: AppDependency[];
  builtInTools?: BuiltInToolCategory[];
  scopes?: string[];
  aiAccessControls?: string[];
  setupInputs?: Record<string, AgentInput>;
  status?: AgentStatus;
  authorName?: string;
};

export type AgentInstanceV2UpdateRequest = {
  id: number;
  snapshotId?: number;
  status: AgentStatus;
  objective: Default<string>;
  /** @deprecated */
  templateName?: string;
  templateId?: number;
  templateMetadata: Default<AgentInstanceTemplateMetadata>;
  workflowId?: number;
  isBreezeEnabled: Default<boolean>;
  /** @deprecated */
  authorName: Default<string>;
  updatedByName?: string;
  createdBy: number;
  createdAt: number;
  updatedAt: Default<number>;
  updatedBy: Default<number>;
  name: string;
  description: string;
  icon?: string;
  modelId?: string;
  modelParameters: Default<ModelParameters>;
  outputType: Default<ResponseSectionType>;
  inputDefinitions: Default<Record<string, AgentInputDefinition>>;
  components: Default<ComponentV2[]>;
  appDependencies: Default<AppDependency[]>;
  builtInTools: Default<BuiltInToolCategory[]>;
  visibility: AgentVisibility;
  scopes: Default<string[]>;
  aiAccessControls: Default<string[]>;
  deletedAt?: number;
  setupInputs: Default<Record<string, AgentInput>>;
  agentSettings: Default<AgentSettings>;
  derivedScopes: Derived<string[]>;
  derivedAiAccessControls: Derived<string[]>;
};

export type AgentUnavailabilityReason =
  | 'INSUFFICIENT_CREDITS'
  | 'RUN_LIMIT_EXCEEDED'
  | unhandledEnumCase;

export type GetAgentInstancesMetadataByIDsRequest = { ids: Default<number[]> };

export type GetAgentInstancesMetadataByIDsResponse = {
  instances: Default<AgentInstanceMetadata[]>;
};

export type AgentAccessType =
  | 'VIEW'
  | 'EDIT'
  | 'RUN'
  | 'MANAGE_AUTOMATIONS'
  | unhandledEnumCase;

export type AgentInstancePermissionWithUserTeamPermissions = {
  portalId: number;
  userTeamPermissions: Default<AgentInstanceUserTeamPermission[]>;
  agentInstanceId: number;
  ownerId: number;
  permissionsMode: Default<AgentPermissionsMode>;
};

export type AgentInstanceUserTeamPermission = {
  id: number;
  agentInstanceId: number;
  entityType: AgentPermissionEntityType;
  entityId: number;
  accessType: AgentAccessType;
};

export type AgentPermissionEntityType = 'USER' | 'TEAM' | unhandledEnumCase;

export type AgentPermissionsMode =
  | 'OPEN'
  | 'ENFORCE_EDIT'
  | 'ENFORCE_EDIT_AND_RUN'
  | 'ENFORCE_ALL'
  | unhandledEnumCase;

export type RecommendationSource =
  | 'AGENT_QUALITY'
  | 'PORTAL_USAGE_CONTEXT'
  | 'JTBD_PROMPT_SUGGESTION'
  | 'PLAN_MODE_DEFAULT'
  | unhandledEnumCase;

export type TriggerFlowId = {
  agentInstanceId: number;
  triggerType: AgentTrigger;
  flowId: number;
};

export type TriggerFlowIdCreate = { triggerType: AgentTrigger; flowId: number };

export type ReadinessValidationReason =
  | 'MISSING_VIEW_PERMISSION'
  | 'MISSING_EDIT_PERMISSION'
  | 'MISSING_RUN_PERMISSION'
  | 'MISSING_BREEZE_AGENT_EDIT_SCOPE'
  | 'MISSING_BREEZE_AGENT_RUN_SCOPE'
  | 'MISSING_BREEZE_AGENT_ADMIN_SCOPE'
  | 'GEN_AI_DISABLED'
  | unhandledEnumCase;

export type VoidResponse = {};

export type AgentConnection = {
  type: AgentConnectionType;
  id: number;
  name?: string;
  description?: string;
  isEnabled?: boolean;
  isModern?: boolean;
};

export type AgentInstancePermissionsUpdate = {
  ownerId: number;
  permissionsMode: AgentPermissionsMode;
  userTeamPermissions: Default<UpdateUserTeamPermission[]>;
};

export type AgentInstanceWithSnapshotRequestItem = {
  agentInstanceId: number;
  snapshotId?: number;
};

export type AgentInstanceWithSnapshotResult = {
  instance: AgentInstanceV2;
  snapshot?: AgentInstanceSnapshot;
};

export type AgentScopeFilter =
  | 'ALL'
  | 'LOCAL_ONLY'
  | 'GLOBAL_ONLY'
  | unhandledEnumCase;

export type BulkCreateAgentInstancesByKeyV2Request = {
  instances: Default<Record<string, AgentInstanceV2CreateRequest>>;
};

export type BulkCreateAgentInstancesByKeyV2Response = {
  instances: Default<Record<string, AgentInstanceV2>>;
};

export type BulkCreateAgentInstancesV2Request = {
  instances: Default<AgentInstanceV2CreateRequest[]>;
};

export type BulkCreateAgentInstancesV2Response = {
  instances: Default<AgentInstanceV2[]>;
};

export type BulkSoftDeleteAgentInstancesV2Request = {
  instanceIds: Default<number[]>;
};

export type BulkSoftDeleteAgentInstancesV2Response = {
  results: Default<Record<string, BulkSoftDeleteResult>>;
};

export type BulkSoftDeleteResult = { deleted: boolean; errorMessage?: string };

export type CloneAgentInstanceRequest = {
  instanceId: number;
  cloneName?: string;
  cloneStatus?: AgentStatus;
  detach: Default<boolean>;
};

export type CloneAgentsForFlowRequest = {
  instanceIds: Default<number[]>;
  newWorkflowId: number;
};

export type CloneAgentsForFlowResponse = {
  clonedInstances: Default<Record<string, AgentInstanceV2>>;
};

export type CloneInstanceFromSnapshotRequest = {
  instanceId: number;
  snapshotId: number;
  cloneName?: string;
  cloneStatus?: AgentStatus;
  detach: Default<boolean>;
};

export type CreateAgentInstanceV2Request = {
  instance: AgentInstanceV2CreateRequest;
  triggerFlowIds: Default<TriggerFlowIdCreate[]>;
  permissions?: AgentInstancePermissionsUpdate;
  feedbackCorrelationId?: string;
};

export type CreateAgentInstanceV2Response = {
  agentInstance: AgentInstanceV2;
  triggerFlowIds: Default<TriggerFlowId[]>;
  permissions?: AgentInstancePermissionWithUserTeamPermissions;
  initialSnapshotId?: number;
};

export type CreateInstanceFromTemplateByGlobalIdRequest = {
  globalId: number;
  globalIdString?: string;
  objective: Default<string>;
  components: Default<ComponentV2[]>;
  builtInTools: Default<BuiltInToolCategory[]>;
  desiredStatus?: AgentStatus;
  detach: Default<boolean>;
};

export type CreateInstanceFromTemplateRequest = {
  templateId: number;
  objective: Default<string>;
  components: Default<ComponentV2[]>;
  builtInTools: Default<BuiltInToolCategory[]>;
  detach: Default<boolean>;
};

export type CreateInstanceFromTemplateResponse = {
  agentInstance: AgentInstanceV2;
  initialSnapshotId?: number;
};

export type GetActiveAgentInstancesV2Request = {
  visibility: AgentVisibility;
  pageLength: Default<number>;
  offset: InstanceV2Cursor;
};

export type GetAgentConnectionsRequest = { agentInstanceId: number };

export type GetAgentConnectionsResponse = {
  connections: Default<AgentConnection[]>;
};

export type GetAgentInstanceV2Request = {
  id: number;
  feedbackCorrelationId?: string;
};

export type GetAgentInstanceV2Response = {
  agentInstance: AgentInstanceV2;
  triggerFlowIds: Default<TriggerFlowId[]>;
  permissions?: AgentInstancePermissionWithUserTeamPermissions;
  activeSnapshotId?: number;
};

export type GetAgentInstancesByWorkflowIdRequest = { workflowId: number };

export type GetAgentInstancesByWorkflowIdResponse = {
  instances: Default<AgentInstanceV2[]>;
};

export type GetAgentInstancesV2ByGlobalIdRequest = {
  globalId: number;
  globalIdString?: string;
};

export type GetAgentInstancesV2ByGlobalIdResponse = {
  instances: Default<AgentInstanceV2[]>;
};

export type GetAgentInstancesV2ByIDsRequest = { ids: Default<number[]> };

export type GetAgentInstancesV2ByIDsResponse = {
  instances: Default<AgentInstanceV2[]>;
  permissions: Default<
    Record<string, AgentInstancePermissionWithUserTeamPermissions>
  >;
};

export type GetAgentInstancesV2ByTemplateIdsRequest = {
  templateIds: Default<number[]>;
};

export type GetAgentInstancesV2ByTemplateIdsResponse = {
  instancesByTemplateId: Default<Record<string, AgentInstanceV2[]>>;
};

export type GetAgentInstancesV2Response = {
  results: Default<AgentInstanceV2[]>;
  offset: InstanceV2Cursor;
  permissions: Default<
    Record<string, AgentInstancePermissionWithUserTeamPermissions>
  >;
  hasMore: boolean;
  requiresJitaPrompt?: boolean;
  portalId?: number;
};

export type GetAgentInstancesWithSnapshotsRequest = {
  items: Default<AgentInstanceWithSnapshotRequestItem[]>;
};

export type GetAgentInstancesWithSnapshotsResponse = {
  results: Default<AgentInstanceWithSnapshotResult[]>;
};

export type GetGlobalAgentConnectionsRequest = {
  agentInstanceId: number;
  filterByConnectionTypes: Default<AgentConnectionType[]>;
  evaluateBreakingChanges: Default<boolean>;
};

export type GetGlobalAgentConnectionsResponse = {
  totalConnections: number;
  connectionsByType: Default<Record<string, ConnectionDetail[]>>;
  brokenWorkflowCount?: number;
};

export type InstanceSortField =
  | 'NAME'
  | 'UPDATED_AT'
  | 'CREATED_AT'
  | unhandledEnumCase;

export type InstanceV2Cursor = {
  offset: Default<number>;
  stringOffset?: string;
};

export type ListAgentInstancesV2Request = {
  /** @deprecated No longer applied as a filter. The authorName column was removed from agent instances in PR #3174, so this value is silently ignored. Use BaseAgentInstancesV2RequestIF#getCreatedBy() to scope results to a creator instead. Retained only so existing callers still deserialize. */
  authorName?: string;
  updatedBy?: number;
  searchTerm?: string;
  adminVisibilityFilter?: AgentVisibility;
  runLimitStatusFilter: Default<RunLimitStatusFilter>;
  pageLength: Default<number>;
  createdBy?: number;
  visibilities: Default<AgentVisibility[]>;
  /** @deprecated */
  visibility: Default<AgentVisibility>;
  requiredAccessType: Default<AgentAccessType>;
  sortField: Default<InstanceSortField>;
  sortDirection: Default<SortDirection>;
  statuses: Default<AgentStatus[]>;
  permissionTypeFilters: Default<AgentAccessType[]>;
  agentScopeFilter: Default<AgentScopeFilter>;
  offset: InstanceV2Cursor;
};

export type PatchAgentInstanceRequest = {
  id: number;
  instance: AgentInstanceV2PartialUpdateRequest;
};

export type ResetToTemplateRequest = { instanceId: number };

export type ResetToTemplateResponse = {
  agentInstance: AgentInstanceV2;
  createdSnapshotId: number;
};

export type RunLimitStatusFilter =
  | 'ALL'
  | 'LIMIT_EXCEEDED'
  | 'WITHIN_LIMIT'
  | unhandledEnumCase;

export type SearchAgentInstancesV2Request = {
  searchTerms: Default<string[]>;
  pageLength: Default<number>;
  createdBy?: number;
  visibilities: Default<AgentVisibility[]>;
  /** @deprecated */
  visibility: Default<AgentVisibility>;
  requiredAccessType: Default<AgentAccessType>;
  sortField: Default<InstanceSortField>;
  sortDirection: Default<SortDirection>;
  statuses: Default<AgentStatus[]>;
  permissionTypeFilters: Default<AgentAccessType[]>;
  agentScopeFilter: Default<AgentScopeFilter>;
  offset: InstanceV2Cursor;
};

export type SoftDeleteAgentInstanceV2Request = {
  id: number;
  feedbackCorrelationId?: string;
};

export type SortDirection = 'ASC' | 'DESC' | unhandledEnumCase;

export type UnpublishAgentInstanceRequest = {
  id: number;
  unpublishReasons: Default<string[]>;
  pendingChanges?: UnpublishPendingChangesRequest;
};

/**
 *  The editor's unsaved state, applied with the same rules as {@code updateAgentInstanceV3} before
 *  the agent is unpublished.
 */
export type UnpublishPendingChangesRequest = {
  instance: AgentInstanceV2UpdateRequest;
  triggerFlowIds: Default<TriggerFlowIdCreate[]>;
  permissions?: AgentInstancePermissionsUpdate;
  clientHeadSnapshotId: number;
};

export type UpdateAgentAvailabilityRequest = {
  id: number;
  isBreezeEnabled: boolean;
};

export type UpdateAgentInstanceFromSnapshotRequest = {
  instanceId: number;
  snapshotId: number;
  additionalSetupInputs?: Record<string, AgentInput>;
  authorName?: string;
  triggerFlowIds?: TriggerFlowIdCreate[];
  permissions?: AgentInstancePermissionsUpdate;
};

export type UpdateAgentInstanceOwnerRequest = {
  agentInstanceId: number;
  newOwnerId: number;
};

export type UpdateAgentInstanceV2Request = {
  id: number;
  instance: AgentInstanceV2UpdateRequest;
  triggerFlowIds: Default<TriggerFlowIdCreate[]>;
  permissions?: AgentInstancePermissionsUpdate;
  feedbackCorrelationId?: string;
  recommendationMetadata?: RecommendationRequestMetadata;
};

export type UpdateAgentInstanceV3Request = {
  id: number;
  instance: AgentInstanceV2UpdateRequest;
  triggerFlowIds: Default<TriggerFlowIdCreate[]>;
  permissions?: AgentInstancePermissionsUpdate;
  feedbackCorrelationId?: string;
  recommendationMetadata?: RecommendationRequestMetadata;
  clientHeadSnapshotId: number;
  forceCreate: Default<boolean>;
};

/**
 *  Request to update the "metadata" (toolbar) fields of an agent instance: name, description, and
 *  icon. Unlike {@link PatchAgentInstanceRequestIF}, updating these fields does not create a new
 *  snapshot/version, since they do not change the agent's behavior.
 */
export type UpdateAgentMetadataRequest = {
  id: number;
  name?: string;
  description?: string;
  icon?: string;
};

/**
 *  Response for {@link UpdateAgentMetadataRequestIF}. Returns only the updated instance, since a
 *  metadata edit does not change trigger flows, permissions, or the active snapshot (the snapshot id
 *  is still available via {@link AgentInstanceV2#getSnapshotId()}).
 */
export type UpdateAgentMetadataResponse = { agentInstance: AgentInstanceV2 };

export type UpdateUserTeamPermission = {
  entityType: AgentPermissionEntityType;
  entityId: number;
  accessType: AgentAccessType;
};

export type AgentInstanceWithInvocability = {
  instance: AgentInstanceV2;
  invocability: AgentInvocabilityResult;
};

export type AgentInvocabilityResult = {
  available: boolean;
  unavailabilityReasons: Default<AgentUnavailabilityReason[]>;
  runLimitDetails?: AgentRunLimitDetails;
};

export type AgentRunLimitDetails = {
  currentMonthlyRunCount: number;
  monthlyRunLimit: number;
  usagePeriodEndMillis?: number;
};

export type ListAgentInstancesWithInvocabilityRequest = {
  pageLength: Default<number>;
  sortField: Default<InstanceSortField>;
  sortDirection: Default<SortDirection>;
  filterToBreezeEnabledOnly: Default<boolean>;
  searchTerm?: string;
  offset: InstanceV2Cursor;
};

export type ListAgentInstancesWithInvocabilityResponse = {
  results: Default<AgentInstanceWithInvocability[]>;
  offset: InstanceV2Cursor;
  hasMore: boolean;
};

export type RecommendationRequestMetadata = {
  recommendationSource: RecommendationSource;
  recommendationId: string;
};

export type AgentFieldValidationResult = {
  fieldName: string;
  passed: boolean;
  failureType?: ValidationFailureType;
  errorMessage?: string;
  /** @deprecated Use getComponentErrors() for structured error messages. This field is kept for backwards compatibility but will be removed in future versions. */
  errorMessages?: string[];
  componentErrors?: ComponentValidationError[];
  missingScopes?: string[];
  missingAccessControls?: string[];
  missingPermissions?: string[];
};

export type AgentPermissionCheckResult = {
  found: boolean;
  hasEditAccess: boolean;
  hasRunAccess: boolean;
};

export type AgentValidationResponse = {
  valid: boolean;
  fieldResults: Default<AgentFieldValidationResult[]>;
  summaryMessage?: string;
};

export type BulkValidateAgentInstancesRequest = {
  instanceIds: Default<number[]>;
};

export type BulkValidateAgentInstancesResponse = {
  results: Default<Record<string, AgentPermissionCheckResult>>;
};

/**
 *  Represents a validation error for a specific component (action, knowledge box, etc.).
 *  This structured format allows the frontend to construct user-facing error messages.
 */
export type ComponentValidationError = {
  componentName: string;
  componentType: string;
  errorType: ValidationFailureType;
  componentId?: string;
};

export type ValidateAgentInstanceReadinessV2Request = {
  agentInstanceId: number;
};

export type ValidateAgentInstanceReadinessV2Response = {
  canView: boolean;
  canEdit: boolean;
  canRun: boolean;
  isGenAiEnabled: boolean;
  hasBreezeAgentEditScope: boolean;
  hasBreezeAgentRunScope: boolean;
  hasBreezeAgentAdminScope: boolean;
  validationReasons: Default<ReadinessValidationReason[]>;
};

export type ValidateAgentInstanceRequest = {
  instanceId?: number;
  instancePayload?: AgentInstanceV2CreateRequest;
  runtimeInputs?: Record<string, AgentInput>;
};

export type ValidationFailureType =
  | 'PERMISSION_DENIED'
  | 'MISSING_SCOPES'
  | 'MISSING_ACCESS_CONTROLS'
  | 'MISSING_PERMISSIONS'
  | 'INVALID_PERMISSIONS'
  | 'INVALID_FORMAT'
  | 'INVALID_LENGTH'
  | 'INVALID_DATA'
  | 'REQUIRED_FIELD_MISSING'
  | 'REQUIRED_PERSISTENT_FIELD_MISSING'
  | 'COMPONENT_NOT_FOUND'
  | 'FILE_INVALID'
  | 'MALICIOUS_CONTENT'
  | 'UNSUPPORTED_VALUE'
  | 'CIRCULAR_REFERENCE'
  | 'INVALID_MODEL'
  | 'INVALID_SCHEMA'
  | 'INPUT_TOO_LARGE'
  | 'AGENT_NOT_EXECUTABLE'
  | unhandledEnumCase;

export type ResponseSectionType =
  | 'DATA_TABLE'
  | 'DATA_TABLE_V2'
  | 'MEDIA'
  | 'MEDIA_V2'
  | 'PLAIN_TEXT'
  | 'HTML'
  | 'HTML_WITH_CHILDREN'
  | 'CARD'
  | 'BAR_CHART'
  | 'IMAGE_GRID'
  | 'ACTION'
  | 'THOUGHT'
  | 'ACCORDION'
  | 'LLM'
  | 'REPORT'
  | 'DASHBOARD'
  | 'FILTER_BRANCH'
  | 'DENSE_LIST'
  | 'CONFIRMATION'
  | 'USER_CHAT'
  | 'USER_ACTION'
  | 'ERROR'
  | 'COLLABORATE'
  | 'CRM_CARD'
  | 'VISUALIZATION'
  | 'SOURCES_LIST'
  | 'GRID'
  | 'TEMPLATE'
  | 'UNSTYLED_IMAGE'
  | 'CARD_WRAPPER'
  | 'FILE_ATTACHMENT'
  | 'CONTEXT_ITEM'
  | 'MEETING'
  | 'METRIC_CARD'
  | 'AVATAR_CARD'
  | 'COMPANY_OVERVIEW'
  | 'NEWS_LIST_CARD'
  | 'TIMELINE_CARD'
  | 'CHIPS_CARD'
  | 'TAB'
  | 'HTML_CARD'
  | 'INLINE_CITATION'
  | 'DRAFT_EMAIL'
  | 'INLINE_ACADEMY_VIDEO'
  | 'GET_TO_KNOW_ME_CARD'
  | 'DATA_CHANGE'
  | 'ASK_QUESTION'
  | 'USER_ALERT'
  | 'SUPPORT_HANDOFF'
  | 'STEP_LIST'
  | 'CALENDAR_CONNECT'
  | 'EMAIL_DRAFT_CARD'
  | 'MEETING_PREP_ACTION_DATA'
  | 'MEETING_RECAP_ACTION_DATA'
  | 'COMPOSABLE_CARD'
  | 'ACADEMY_CATALOG_RECOMMENDATION_CARD'
  | 'MEETING_CARD'
  | 'ARTIFACT_CARD'
  | 'HIGHCHARTS_CHART'
  | 'MARKETPLACE_CARD'
  | 'CUSTOM_COMPONENT'
  | 'SCHEDULED_PROMPT'
  | 'ACADEMY_PLAYLIST_SUGGESTION'
  | 'IN_CHAT_OBJECT_UPDATE'
  | unhandledEnumCase;

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export const BooleanFieldValueTypename =
  'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export type BooleanFieldValue = {
  value: boolean;
  __typename: 'com.hubspot.chirp.ext.models.BooleanFieldValue';
} & { '@type'?: 'boolean' };

export const DoubleFieldValueTypename =
  'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export type DoubleFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.DoubleFieldValue';
} & { '@type'?: 'double' };

export const FieldValueDiscriminantKey = '@type';
export type FieldValue =
  | NullFieldValue
  | BooleanFieldValue
  | DoubleFieldValue
  | FloatFieldValue
  | IntFieldValue
  | LongFieldValue
  | StringFieldValue
  | ListFieldValue
  | MapFieldValue;

export const FloatFieldValueTypename =
  'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export type FloatFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.FloatFieldValue';
} & { '@type'?: 'float' };

export const IntFieldValueTypename =
  'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export type IntFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.IntFieldValue';
} & { '@type'?: 'integer' };

export const ListFieldValueTypename =
  'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export type ListFieldValue = {
  value: Default<FieldValue[]>;
  __typename: 'com.hubspot.chirp.ext.models.ListFieldValue';
} & { '@type'?: 'list' };

export const LongFieldValueTypename =
  'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export type LongFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.LongFieldValue';
} & { '@type'?: 'long' };

export const MapFieldValueTypename =
  'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export type MapFieldValue = {
  value: Default<Record<string, FieldValue>>;
  __typename: 'com.hubspot.chirp.ext.models.MapFieldValue';
} & { '@type'?: 'map' };

export const NullFieldValueTypename =
  'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export type NullFieldValue = {
  __typename: 'com.hubspot.chirp.ext.models.NullFieldValue';
} & { '@type'?: 'null' };

export const StringFieldValueTypename =
  'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export type StringFieldValue = {
  value: string;
  __typename: 'com.hubspot.chirp.ext.models.StringFieldValue';
} & { '@type'?: 'string' };

export type ObjectCoordinates = {
  portalId: number;
  objectTypeId: string;
  objectId: number;
};

export type GetAgentInstanceRequestType = Requestify<GetAgentInstanceV2Request>;
export type GetAgentInstanceResponseType = GetAgentInstanceV2Response;
export type GetAgentInstanceErrorType = AiAgentError & HubspotMetadata;
export const getAgentInstanceRpc: ChirpAvroRpcDetails<
  GetAgentInstanceRequestType,
  GetAgentInstanceResponseType,
  GetAgentInstanceErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYjc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAgentInstancesByIDsRequestType =
  Requestify<GetAgentInstancesV2ByIDsRequest>;
export type GetAgentInstancesByIDsResponseType =
  GetAgentInstancesV2ByIDsResponse;
export type GetAgentInstancesByIDsErrorType = AiAgentError & HubspotMetadata;
export const getAgentInstancesByIDsRpc: ChirpAvroRpcDetails<
  GetAgentInstancesByIDsRequestType,
  GetAgentInstancesByIDsResponseType,
  GetAgentInstancesByIDsErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByIDs',
  auth: 'app',
  fingerprint: 'v_Hi8JpYU3gGmjrIbILShSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAgentInstancesMetadataByIDsRequestType =
  Requestify<GetAgentInstancesMetadataByIDsRequest>;
export type GetAgentInstancesMetadataByIDsResponseType =
  GetAgentInstancesMetadataByIDsResponse;
export type GetAgentInstancesMetadataByIDsErrorType = AiAgentError &
  HubspotMetadata;
export const getAgentInstancesMetadataByIDsRpc: ChirpAvroRpcDetails<
  GetAgentInstancesMetadataByIDsRequestType,
  GetAgentInstancesMetadataByIDsResponseType,
  GetAgentInstancesMetadataByIDsErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesMetadataByIDs',
  auth: 'app',
  fingerprint: 'KkCtLaXxTCouhohdCRceWic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAgentInstancesWithSnapshotsRequestType =
  Requestify<GetAgentInstancesWithSnapshotsRequest>;
export type GetAgentInstancesWithSnapshotsResponseType =
  GetAgentInstancesWithSnapshotsResponse;
export type GetAgentInstancesWithSnapshotsErrorType = AiAgentError &
  HubspotMetadata;
export const getAgentInstancesWithSnapshotsRpc: ChirpAvroRpcDetails<
  GetAgentInstancesWithSnapshotsRequestType,
  GetAgentInstancesWithSnapshotsResponseType,
  GetAgentInstancesWithSnapshotsErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesWithSnapshots',
  auth: 'app',
  fingerprint: '9QKX_6KF_GH46JzOgIl4SCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAgentInstancesByWorkflowIdRequestType =
  Requestify<GetAgentInstancesByWorkflowIdRequest>;
export type GetAgentInstancesByWorkflowIdResponseType =
  GetAgentInstancesByWorkflowIdResponse;
export type GetAgentInstancesByWorkflowIdErrorType = AiAgentError &
  HubspotMetadata;
export const getAgentInstancesByWorkflowIdRpc: ChirpAvroRpcDetails<
  GetAgentInstancesByWorkflowIdRequestType,
  GetAgentInstancesByWorkflowIdResponseType,
  GetAgentInstancesByWorkflowIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentInstancesByWorkflowId',
  auth: 'app',
  fingerprint: 'jhR4yXLMTW1el77g2jQ59Sc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetActiveAgentInstancesRequestType =
  Requestify<GetActiveAgentInstancesV2Request>;
export type GetActiveAgentInstancesResponseType = GetAgentInstancesV2Response;
export type GetActiveAgentInstancesErrorType = AiAgentError & HubspotMetadata;
export const getActiveAgentInstancesRpc: ChirpAvroRpcDetails<
  GetActiveAgentInstancesRequestType,
  GetActiveAgentInstancesResponseType,
  GetActiveAgentInstancesErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getActiveAgentInstances',
  auth: 'app',
  fingerprint: 'tt8k1TqizUbrdg7NfzqL_ic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListAgentInstancesRequestType =
  Requestify<ListAgentInstancesV2Request>;
export type ListAgentInstancesResponseType = GetAgentInstancesV2Response;
export type ListAgentInstancesErrorType = AiAgentError & HubspotMetadata;
export const listAgentInstancesRpc: ChirpAvroRpcDetails<
  ListAgentInstancesRequestType,
  ListAgentInstancesResponseType,
  ListAgentInstancesErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'listAgentInstances',
  auth: 'app',
  fingerprint: 'Ck0qC16a3i3rdg7NfzqL_ic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SearchAgentInstancesRequestType =
  Requestify<SearchAgentInstancesV2Request>;
export type SearchAgentInstancesResponseType = GetAgentInstancesV2Response;
export type SearchAgentInstancesErrorType = AiAgentError & HubspotMetadata;
export const searchAgentInstancesRpc: ChirpAvroRpcDetails<
  SearchAgentInstancesRequestType,
  SearchAgentInstancesResponseType,
  SearchAgentInstancesErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'searchAgentInstances',
  auth: 'app',
  fingerprint: 'QfOt54bu5dnrdg7NfzqL_ic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateAgentInstanceRequestType =
  Requestify<CreateAgentInstanceV2Request>;
export type CreateAgentInstanceResponseType = CreateAgentInstanceV2Response;
export type CreateAgentInstanceErrorType = AiAgentError & HubspotMetadata;
export const createAgentInstanceRpc: ChirpAvroRpcDetails<
  CreateAgentInstanceRequestType,
  CreateAgentInstanceResponseType,
  CreateAgentInstanceErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createAgentInstance',
  auth: 'app',
  fingerprint: 'mou5rilMa7oFNFx6FbjN9Sc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAgentInstanceV2RequestType =
  Requestify<UpdateAgentInstanceV2Request>;
export type UpdateAgentInstanceV2ResponseType = GetAgentInstanceV2Response;
export type UpdateAgentInstanceV2ErrorType = AiAgentError & HubspotMetadata;
export const updateAgentInstanceV2Rpc: ChirpAvroRpcDetails<
  UpdateAgentInstanceV2RequestType,
  UpdateAgentInstanceV2ResponseType,
  UpdateAgentInstanceV2ErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceV2',
  auth: 'app',
  fingerprint: 'sCfRHXdOZonc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAgentInstanceV3RequestType =
  Requestify<UpdateAgentInstanceV3Request>;
export type UpdateAgentInstanceV3ResponseType = GetAgentInstanceV2Response;
export type UpdateAgentInstanceV3ErrorType = AiAgentError & HubspotMetadata;
export const updateAgentInstanceV3Rpc: ChirpAvroRpcDetails<
  UpdateAgentInstanceV3RequestType,
  UpdateAgentInstanceV3ResponseType,
  UpdateAgentInstanceV3ErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceV3',
  auth: 'app',
  fingerprint: 'OPWq5tjWrxnc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PatchAgentInstanceRequestType =
  Requestify<PatchAgentInstanceRequest>;
export type PatchAgentInstanceResponseType = GetAgentInstanceV2Response;
export type PatchAgentInstanceErrorType = AiAgentError & HubspotMetadata;
export const patchAgentInstanceRpc: ChirpAvroRpcDetails<
  PatchAgentInstanceRequestType,
  PatchAgentInstanceResponseType,
  PatchAgentInstanceErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'patchAgentInstance',
  auth: 'app',
  fingerprint: 'BLNX__ZyDLHc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAgentMetadataRequestType =
  Requestify<UpdateAgentMetadataRequest>;
export type UpdateAgentMetadataResponseType = UpdateAgentMetadataResponse;
export type UpdateAgentMetadataErrorType = AiAgentError & HubspotMetadata;
export const updateAgentMetadataRpc: ChirpAvroRpcDetails<
  UpdateAgentMetadataRequestType,
  UpdateAgentMetadataResponseType,
  UpdateAgentMetadataErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentMetadata',
  auth: 'app',
  fingerprint: '61HkWFDvVbx7xtM3Mk5EACc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAgentAvailabilityRequestType =
  Requestify<UpdateAgentAvailabilityRequest>;
export type UpdateAgentAvailabilityResponseType = GetAgentInstanceV2Response;
export type UpdateAgentAvailabilityErrorType = AiAgentError & HubspotMetadata;
export const updateAgentAvailabilityRpc: ChirpAvroRpcDetails<
  UpdateAgentAvailabilityRequestType,
  UpdateAgentAvailabilityResponseType,
  UpdateAgentAvailabilityErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentAvailability',
  auth: 'app',
  fingerprint: 'Ogp6B8VUuGPc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UnpublishAgentInstanceRequestType =
  Requestify<UnpublishAgentInstanceRequest>;
export type UnpublishAgentInstanceResponseType = GetAgentInstanceV2Response;
export type UnpublishAgentInstanceErrorType = AiAgentError & HubspotMetadata;
export const unpublishAgentInstanceRpc: ChirpAvroRpcDetails<
  UnpublishAgentInstanceRequestType,
  UnpublishAgentInstanceResponseType,
  UnpublishAgentInstanceErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'unpublishAgentInstance',
  auth: 'app',
  fingerprint: 'VNxqAkF4Adjc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ResetToLatestTemplateRequestType =
  Requestify<ResetToTemplateRequest>;
export type ResetToLatestTemplateResponseType = ResetToTemplateResponse;
export type ResetToLatestTemplateErrorType = AiAgentError & HubspotMetadata;
export const resetToLatestTemplateRpc: ChirpAvroRpcDetails<
  ResetToLatestTemplateRequestType,
  ResetToLatestTemplateResponseType,
  ResetToLatestTemplateErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'resetToLatestTemplate',
  auth: 'app',
  fingerprint: 'Im2kC-4d0BuhfU8GFqWItSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SoftDeleteAgentInstanceRequestType =
  Requestify<GetAgentInstanceV2Request>;
export type SoftDeleteAgentInstanceResponseType = VoidResponse;
export type SoftDeleteAgentInstanceErrorType = AiAgentError & HubspotMetadata;
export const softDeleteAgentInstanceRpc: ChirpAvroRpcDetails<
  SoftDeleteAgentInstanceRequestType,
  SoftDeleteAgentInstanceResponseType,
  SoftDeleteAgentInstanceErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstance',
  auth: 'app',
  fingerprint: 'luxHuQpJJYhzxnLXxOhAlyc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SoftDeleteAgentInstanceV2RequestType =
  Requestify<SoftDeleteAgentInstanceV2Request>;
export type SoftDeleteAgentInstanceV2ResponseType = VoidResponse;
export type SoftDeleteAgentInstanceV2ErrorType = AiAgentError & HubspotMetadata;
export const softDeleteAgentInstanceV2Rpc: ChirpAvroRpcDetails<
  SoftDeleteAgentInstanceV2RequestType,
  SoftDeleteAgentInstanceV2ResponseType,
  SoftDeleteAgentInstanceV2ErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'softDeleteAgentInstanceV2',
  auth: 'app',
  fingerprint: 'bquNPpxFM9hzxnLXxOhAlyc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateInstanceFromTemplateRequestType =
  Requestify<CreateInstanceFromTemplateRequest>;
export type CreateInstanceFromTemplateResponseType =
  CreateInstanceFromTemplateResponse;
export type CreateInstanceFromTemplateErrorType = AiAgentError &
  HubspotMetadata;
export const createInstanceFromTemplateRpc: ChirpAvroRpcDetails<
  CreateInstanceFromTemplateRequestType,
  CreateInstanceFromTemplateResponseType,
  CreateInstanceFromTemplateErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplate',
  auth: 'app',
  fingerprint: '8XE4Oz-YCFAdPRStO8zNUCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateInstanceFromTemplateByGlobalIdRequestType =
  Requestify<CreateInstanceFromTemplateByGlobalIdRequest>;
export type CreateInstanceFromTemplateByGlobalIdResponseType =
  CreateInstanceFromTemplateResponse;
export type CreateInstanceFromTemplateByGlobalIdErrorType = AiAgentError &
  HubspotMetadata;
export const createInstanceFromTemplateByGlobalIdRpc: ChirpAvroRpcDetails<
  CreateInstanceFromTemplateByGlobalIdRequestType,
  CreateInstanceFromTemplateByGlobalIdResponseType,
  CreateInstanceFromTemplateByGlobalIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'createInstanceFromTemplateByGlobalId',
  auth: 'app',
  fingerprint: 'FMIVBMCv7ocdPRStO8zNUCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CloneAgentInstanceRequestType =
  Requestify<CloneAgentInstanceRequest>;
export type CloneAgentInstanceResponseType = CreateInstanceFromTemplateResponse;
export type CloneAgentInstanceErrorType = AiAgentError & HubspotMetadata;
export const cloneAgentInstanceRpc: ChirpAvroRpcDetails<
  CloneAgentInstanceRequestType,
  CloneAgentInstanceResponseType,
  CloneAgentInstanceErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentInstance',
  auth: 'app',
  fingerprint: 'IDPzP_Tubm0dPRStO8zNUCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CloneAgentsForFlowRequestType =
  Requestify<CloneAgentsForFlowRequest>;
export type CloneAgentsForFlowResponseType = CloneAgentsForFlowResponse;
export type CloneAgentsForFlowErrorType = AiAgentError & HubspotMetadata;
export const cloneAgentsForFlowRpc: ChirpAvroRpcDetails<
  CloneAgentsForFlowRequestType,
  CloneAgentsForFlowResponseType,
  CloneAgentsForFlowErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneAgentsForFlow',
  auth: 'app',
  fingerprint: 'LVwvv72TyJlehC9hm_tAoSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetInstancesByTemplateIdsRequestType =
  Requestify<GetAgentInstancesV2ByTemplateIdsRequest>;
export type GetInstancesByTemplateIdsResponseType =
  GetAgentInstancesV2ByTemplateIdsResponse;
export type GetInstancesByTemplateIdsErrorType = AiAgentError & HubspotMetadata;
export const getInstancesByTemplateIdsRpc: ChirpAvroRpcDetails<
  GetInstancesByTemplateIdsRequestType,
  GetInstancesByTemplateIdsResponseType,
  GetInstancesByTemplateIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByTemplateIds',
  auth: 'app',
  fingerprint: 'Bao0fja8a35i7bgkmuGn_Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetInstancesByGlobalIdRequestType =
  Requestify<GetAgentInstancesV2ByGlobalIdRequest>;
export type GetInstancesByGlobalIdResponseType =
  GetAgentInstancesV2ByGlobalIdResponse;
export type GetInstancesByGlobalIdErrorType = AiAgentError & HubspotMetadata;
export const getInstancesByGlobalIdRpc: ChirpAvroRpcDetails<
  GetInstancesByGlobalIdRequestType,
  GetInstancesByGlobalIdResponseType,
  GetInstancesByGlobalIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getInstancesByGlobalId',
  auth: 'app',
  fingerprint: 'yPtD4Qwpkj-tVZ9-DZ6LtSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAgentInstanceOwnerRequestType =
  Requestify<UpdateAgentInstanceOwnerRequest>;
export type UpdateAgentInstanceOwnerResponseType = VoidResponse;
export type UpdateAgentInstanceOwnerErrorType = AiAgentError & HubspotMetadata;
export const updateAgentInstanceOwnerRpc: ChirpAvroRpcDetails<
  UpdateAgentInstanceOwnerRequestType,
  UpdateAgentInstanceOwnerResponseType,
  UpdateAgentInstanceOwnerErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceOwner',
  auth: 'app',
  fingerprint: 'biKggbtMJGFzxnLXxOhAlyc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAgentInstanceFromSnapshotRequestType =
  Requestify<UpdateAgentInstanceFromSnapshotRequest>;
export type UpdateAgentInstanceFromSnapshotResponseType =
  GetAgentInstanceV2Response;
export type UpdateAgentInstanceFromSnapshotErrorType = AiAgentError &
  HubspotMetadata;
export const updateAgentInstanceFromSnapshotRpc: ChirpAvroRpcDetails<
  UpdateAgentInstanceFromSnapshotRequestType,
  UpdateAgentInstanceFromSnapshotResponseType,
  UpdateAgentInstanceFromSnapshotErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'updateAgentInstanceFromSnapshot',
  auth: 'app',
  fingerprint: 'vxmtmtyT79zc5eDyATDI9Cc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CloneInstanceFromSnapshotRequestType =
  Requestify<CloneInstanceFromSnapshotRequest>;
export type CloneInstanceFromSnapshotResponseType =
  CreateInstanceFromTemplateResponse;
export type CloneInstanceFromSnapshotErrorType = AiAgentError & HubspotMetadata;
export const cloneInstanceFromSnapshotRpc: ChirpAvroRpcDetails<
  CloneInstanceFromSnapshotRequestType,
  CloneInstanceFromSnapshotResponseType,
  CloneInstanceFromSnapshotErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'cloneInstanceFromSnapshot',
  auth: 'app',
  fingerprint: 'jfr4Elt4T0UdPRStO8zNUCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ValidateAgentInstanceReadinessRequestType =
  Requestify<ValidateAgentInstanceRequest>;
export type ValidateAgentInstanceReadinessResponseType =
  AgentValidationResponse;
export type ValidateAgentInstanceReadinessErrorType = AiAgentError &
  HubspotMetadata;
export const validateAgentInstanceReadinessRpc: ChirpAvroRpcDetails<
  ValidateAgentInstanceReadinessRequestType,
  ValidateAgentInstanceReadinessResponseType,
  ValidateAgentInstanceReadinessErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadiness',
  auth: 'app',
  fingerprint: '7UOpVPNjQSZHKNNd4MLGeCc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ValidateAgentInstanceReadinessV2RequestType =
  Requestify<ValidateAgentInstanceReadinessV2Request>;
export type ValidateAgentInstanceReadinessV2ResponseType =
  ValidateAgentInstanceReadinessV2Response;
export type ValidateAgentInstanceReadinessV2ErrorType = AiAgentError &
  HubspotMetadata;
export const validateAgentInstanceReadinessV2Rpc: ChirpAvroRpcDetails<
  ValidateAgentInstanceReadinessV2RequestType,
  ValidateAgentInstanceReadinessV2ResponseType,
  ValidateAgentInstanceReadinessV2ErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'validateAgentInstanceReadinessV2',
  auth: 'app',
  fingerprint: '_y3TSpR__PPlnnLyhTfIOSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type BulkValidateAgentInstancesReadinessRequestType =
  Requestify<BulkValidateAgentInstancesRequest>;
export type BulkValidateAgentInstancesReadinessResponseType =
  BulkValidateAgentInstancesResponse;
export type BulkValidateAgentInstancesReadinessErrorType = AiAgentError &
  HubspotMetadata;
export const bulkValidateAgentInstancesReadinessRpc: ChirpAvroRpcDetails<
  BulkValidateAgentInstancesReadinessRequestType,
  BulkValidateAgentInstancesReadinessResponseType,
  BulkValidateAgentInstancesReadinessErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkValidateAgentInstancesReadiness',
  auth: 'app',
  fingerprint: 'ate6fB_EofplU4ciiiItdic3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type BulkCreateAgentInstancesRequestType =
  Requestify<BulkCreateAgentInstancesV2Request>;
export type BulkCreateAgentInstancesResponseType =
  BulkCreateAgentInstancesV2Response;
export type BulkCreateAgentInstancesErrorType = AiAgentError & HubspotMetadata;
export const bulkCreateAgentInstancesRpc: ChirpAvroRpcDetails<
  BulkCreateAgentInstancesRequestType,
  BulkCreateAgentInstancesResponseType,
  BulkCreateAgentInstancesErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstances',
  auth: 'app',
  fingerprint: 'av4zjDNJYTYr3lBdYSDWayc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type BulkCreateAgentInstancesByKeyRequestType =
  Requestify<BulkCreateAgentInstancesByKeyV2Request>;
export type BulkCreateAgentInstancesByKeyResponseType =
  BulkCreateAgentInstancesByKeyV2Response;
export type BulkCreateAgentInstancesByKeyErrorType = AiAgentError &
  HubspotMetadata;
export const bulkCreateAgentInstancesByKeyRpc: ChirpAvroRpcDetails<
  BulkCreateAgentInstancesByKeyRequestType,
  BulkCreateAgentInstancesByKeyResponseType,
  BulkCreateAgentInstancesByKeyErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkCreateAgentInstancesByKey',
  auth: 'app',
  fingerprint: 'af9mI7OiwG81EY0Sbex4fSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type BulkSoftDeleteAgentInstancesRequestType =
  Requestify<BulkSoftDeleteAgentInstancesV2Request>;
export type BulkSoftDeleteAgentInstancesResponseType =
  BulkSoftDeleteAgentInstancesV2Response;
export type BulkSoftDeleteAgentInstancesErrorType = AiAgentError &
  HubspotMetadata;
export const bulkSoftDeleteAgentInstancesRpc: ChirpAvroRpcDetails<
  BulkSoftDeleteAgentInstancesRequestType,
  BulkSoftDeleteAgentInstancesResponseType,
  BulkSoftDeleteAgentInstancesErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'bulkSoftDeleteAgentInstances',
  auth: 'app',
  fingerprint: 'lQSah62WeHRlIE2fHG1Qwyc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAgentConnectionsRequestType =
  Requestify<GetAgentConnectionsRequest>;
export type GetAgentConnectionsResponseType = GetAgentConnectionsResponse;
export type GetAgentConnectionsErrorType = AiAgentError & HubspotMetadata;
export const getAgentConnectionsRpc: ChirpAvroRpcDetails<
  GetAgentConnectionsRequestType,
  GetAgentConnectionsResponseType,
  GetAgentConnectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getAgentConnections',
  auth: 'app',
  fingerprint: 'L5P9kdUDyVu5RJ9mIMBXkSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetGlobalAgentConnectionsRequestType =
  Requestify<GetGlobalAgentConnectionsRequest>;
export type GetGlobalAgentConnectionsResponseType =
  GetGlobalAgentConnectionsResponse;
export type GetGlobalAgentConnectionsErrorType = AiAgentError & HubspotMetadata;
export const getGlobalAgentConnectionsRpc: ChirpAvroRpcDetails<
  GetGlobalAgentConnectionsRequestType,
  GetGlobalAgentConnectionsResponseType,
  GetGlobalAgentConnectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'getGlobalAgentConnections',
  auth: 'app',
  fingerprint: 'Al5CHVrqM_eOIu_L9G7zECc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListAgentInstancesWithInvocabilityRequestType =
  Requestify<ListAgentInstancesWithInvocabilityRequest>;
export type ListAgentInstancesWithInvocabilityResponseType =
  ListAgentInstancesWithInvocabilityResponse;
export type ListAgentInstancesWithInvocabilityErrorType = AiAgentError &
  HubspotMetadata;
export const listAgentInstancesWithInvocabilityRpc: ChirpAvroRpcDetails<
  ListAgentInstancesWithInvocabilityRequestType,
  ListAgentInstancesWithInvocabilityResponseType,
  ListAgentInstancesWithInvocabilityErrorType,
  false
> = {
  serviceName: 'com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2',
  rpcName: 'listAgentInstancesWithInvocability',
  auth: 'app',
  fingerprint: 'bGOX9ZnU2z5H3rWH38_sHSc3jg_1vIXL',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
